import { makeMergeSubscribersAPI } from 'common/audience/api/audienceMergeApi'
import { makeNotificationsAPI } from 'common/core/components/NotifyBar/api/notificationsAPI'
import FieldsAPI from 'common/fields/api/fieldsAPI'
import { McAPI, RootAPI } from 'utils/api/types'
import { accountNotificationsListener } from 'utils/services/notificationsService'
import { NotificationsListener } from 'utils/services/notificationsService/notificationsServiceTypes'

export interface DisposableRootAPI extends RootAPI {
  dispose: () => void
}

/**
 * Creates an API that owns its FieldsAPI notification subscriptions and update callback.
 * Pass a scoped listener in integration tests; production defaults to account notifications.
 * The creator calls `api.dispose()` after its consumers unmount. It is safe to repeat;
 * providers borrowing a shared API (including the app singleton) must not dispose it.
 * Pending requests still settle normally, but cannot notify the released field listener.
 */
export const makeAPI = (
  mcApi: McAPI,
  notificationsListener: NotificationsListener = accountNotificationsListener,
): DisposableRootAPI => {
  const fields = new FieldsAPI(mcApi, notificationsListener)

  return {
    ...mcApi,
    fields,
    notifications: makeNotificationsAPI(mcApi),
    mergerSubscribers: makeMergeSubscribersAPI(mcApi),
    dispose: fields.dispose,
  }
}
